import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
import { Flex } from '@mantine/core'

export const StyledCommunityBanner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 16px;
  ${MediaQueries.mbDown} {
    padding: 16px;
  }
  .community {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 24px;
  }
  background: ${theme.colors.primary50};
  border-radius: ${theme.borderRadius};
  .thumbnail-header {
    width: 80px;
    background: transparent;
    /* White */
    border: 4px solid #ffffff;
    border-radius: 8px;

    ${MediaQueries.mbDown} {
      width: 48px;
    }
  }
  .detail {
    width: 100%;
  }
  .detail-general {
    min-height: 50px;
    width: 100%;
    display: flex;
    ${MediaQueries.mbUp} {
      justify-content: space-between;
    }
  }
`

export const StyledCommunityRevamp = styled(Flex)`
  border-radius: 8px;

  .thumbnail {
    display: block;
    min-width: 48px;
    width: 48px;
    height: 48px;

    img {
      border-radius: 8px;
    }
  }
`
